var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_ol_map_view_interface = function () {
    OCS.Viewer.Interfaces.OlMapView = {
        add_events: function () {
            this.add_change_event(this.options.center_string, this.handle_update_center, this);
        },
        create_view: function (view_ops) {
            this.set_ol_object(new ol.View(view_ops));
        },
        calculate_extent: function (size) {
            return this.ol_object.calculateExtent(size);
        },

        mutually_bind_view: function(target_map_view) {
            this.link_bindings.push(this.bind_property(target_map_view.get_view(), this.options.center_string));
            this.link_bindings.push(target_map_view.bind_property(this.get_view(), this.options.center_string));
            this.link_bindings.push(this.bind_property(target_map_view.get_view(), this.options.resolution_string));
            this.link_bindings.push(target_map_view.bind_property(this.get_view(), this.options.resolution_string));            
        },
        unbind_view: function () {
            this.link_bindings.each(function(bind_id) {
                this.unbind_property(bind_id);
            }.bind(this));
        },
        fit: function (extent, size) {
            this.ol_object.fit(extent, size);
        },
        handle_update_center: function (e) {
            this.options.center = ol.proj.transform(this.ol_object.getCenter(), this.options.projection, this.options.display_projection);
        },
        /* 
         * Get and Set Methods
         */


        /**
         * 
         * @param {type} map_center [longitude {Float} The longitude coordinate of the center point, latitude  {Float} The latitude coordinate of the center point]
         * @returns {undefined}
         */
        set_center: function (map_center) {
            this.options.center = map_center;
            this.ol_object.setCenter(ol.proj.transform(this.options.center, this.options.display_projection, this.options.projection));
        },
        get_center: function () {
            return this.options.center;
        },
        get_display_projection: function () {
            return this.options.display_projection;
        },
        get_projection: function () {
            return this.options.projection;
        },
        get_resolution: function () {
            return this.ol_object.getResolution();
        },
        set_resolution: function (resolution) {
            this.ol_object.setResolution(Number(resolution));
        },
        get_view: function () {
            return this.get_ol_object();
        },
        get_zoom: function () {
            return this.ol_object.getZoom();
        },
        set_zoom: function (zoom) {
            this.ol_object.setZoom(zoom);
        }
    };
};
OCS.Viewer.Functions.define_ol_map_view_interface();